import { SelectInput, useInput } from "react-admin";
import { apiUrl } from "../../dataProvider";
import { useEffect, useState } from "react";
import axios from 'axios';
import { FormHelperText } from '@material-ui/core';

const CustomAdminSelect = ({ label, source, validate, defaultValue, resource, optionValue = 'id', optionLabel = 'name', disabled = false }) => {
  // const { input, isRequired, meta: { touched, error, } } = useInput({ source, validate, defaultValue })
  const [list, setList] = useState([]);

  useEffect(() => {
    fetchResources();
  }, [resource]);

  const fetchResources = async () => {
    const url = `${apiUrl}/${resource}`;
    const response = await axios.get(url).then(({ data }) => data);
    const data = response.data || response;

    if (Array.isArray(data)) {
      if (typeof data[0] === 'string' || typeof data[0] === 'number') {
          const formattedResponse = data.map(item => ({ id: item, name: item, sku_code: item }));
          setList(formattedResponse);
      } else {
          const formattedResponse = data.map(item => ({ id: item[optionValue], name: item[optionLabel] }));
          setList(formattedResponse);
      }
    }
  }
  return (
    <>
      <SelectInput
        label={label}
        source={source}
        choices={list}
        validate={validate}
        fullWidth
        disabled={disabled}
      />
    </>
  )
}

export default CustomAdminSelect;